module.exports = __webpack_public_path__ + "img/rightside_1000.06618191.png";